export enum TrackerTriggerTypeMobile {
  APP_STATE_CHANGE = "APP_STATE_CHANGE",
  CUSTOM = "CUSTOM",
  APPLICATION_OPEN = "APPLICATION_OPEN",
  NETWORK_CHANGE = "NETWORK_CHANGE",
  APP_CALL_END = "APP_CALL_END",
  APP_CALL_START = "APP_CALL_START",
  APP_CALL_RING = "APP_CALL_RING",
  APP_CALL_REJECT = "APP_CALL_REJECT",
  SCREEN_RECORD_END = "SCREEN_RECORD_END",
  SCREEN_RECORD_START = "SCREEN_RECORD_START",
}

export enum TrackerTriggerTypeWeb {
  CLICK = "CLICK",
  SCROLL = "SCROLL",
  PAGE_VIEW = "PAGE_VIEW",
  CUSTOM = "CUSTOM",
  RISK_ALERT = "RISK_ALERT",
}
